<template>
  <site-layout id="app">
    <router-view />
  </site-layout>
</template>

<script>
import SiteLayout from '@/components/layout/SiteLayout'

export default {
  components: {
    SiteLayout
  }
}
</script>
